import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Links,
} from "react-router-dom";
const Sidebar = ({ isOpen }) => {
  return (
    <div>
      <aside id='sidebar' className={`sidebar ${isOpen ? "active" : ""}`}>
        <ul className='sidebar-nav' id='sidebar-nav'>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/'>
              <i className='bi bi-grid text-primary '></i>
              <span>Dashboard</span>
            </Link>
          </li>
          <li className='nav-item'>
            <a
              className='nav-link collapsed'
              data-bs-target='#components-nav3'
              data-bs-toggle='collapse'
              href='#'
            >
              <i className='bi bi-check-circle-fill text-primary'></i>
              <span>Leads</span>
              <i className='bi bi-chevron-down ms-auto'></i>
            </a>
            <ul
              id='components-nav3'
              className='nav-content collapse '
              data-bs-parent='#sidebar-nav'
            >
              <li>
                <Link to='/real-do-leads'>
                  <i className='bi bi-circle'></i>
                  <span>Real Do</span>
                </Link>
              </li>
              <li>
              <Link to='/sai-leads'>
                  <i className='bi bi-circle'></i>
                  <span>SAI Branding</span>
                </Link>
              </li>
            </ul>
          </li>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/clients'>
              <i className='bi bi-person-circle text-primary'></i>
              <span>Clients</span>
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/property'>
              <i className='bi bi-house-check-fill text-primary'></i>
              <span>Property</span>
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/project'>
              <i className='bi bi-building-fill-check  text-primary'></i>
              <span>Project</span>
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/broker'>
              <i className='bi bi-suitcase-lg-fill text-primary'></i>
              <span>Broker</span>
            </Link>
          </li>

          <li className='nav-item'>
            <a
              className='nav-link collapsed'
              data-bs-target='#components-nav'
              data-bs-toggle='collapse'
              href='#'
            >
              <i className='bi bi-menu-button-wide text-primary'></i>
              <span>Templates</span>
              <i className='bi bi-chevron-down ms-auto'></i>
            </a>
            <ul
              id='components-nav'
              className='nav-content collapse '
              data-bs-parent='#sidebar-nav'
            >
              <li>
              <Link to='/sms-template'>
                  <i className='bi bi-circle'></i>
                  <span>SMS Templates</span>
                </Link>
              </li>
              <li>
                <Link to='/wp-template'>
                  <i className='bi bi-circle'></i>
                  <span>What's App Templates</span>
                </Link>
              </li>
            </ul>
          </li>
          <li className='nav-item'>
            <a
              className='nav-link collapsed'
              data-bs-target='#components-nav2'
              data-bs-toggle='collapse'
              href='#'
            >
              <i className='bi bi-gear text-primary'></i>
              <span>Settings</span>
              <i className='bi bi-chevron-down ms-auto'></i>
            </a>
            <ul
              id='components-nav2'
              className='nav-content collapse '
              data-bs-parent='#sidebar-nav'
            >
              <li>
                <Link to='/staff'>
                  <i className='bi bi-circle'></i>
                  <span>Total Staff</span>
                </Link>
              </li>
              <li>
                <Link to='/audit'>
                  <i className='bi bi-circle'></i>
                  <span>Audit Trail</span>
                </Link>
              </li>
            </ul>
          </li>

          <li className='nav-heading'>Others</li>

          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/profile'>
              <i className='bi bi-person-circle'></i>
              <span>Profile</span>
            </Link>
          </li>
          <li className='nav-item'>
            <Link className='nav-link collapsed' to='/login'>
              <i className='bi bi-box-arrow-in-right'></i>
              <span>Log-Out</span>
            </Link>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;
